import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';

interface WorkPointsPostState {
  dialogOpen: boolean

  status: APIRequestStatus
  error: string
}

const initialState: WorkPointsPostState = {
    dialogOpen: false,

    status: APIRequestStatus.Idle,
    error: ''
}

const workPointsPostSlice = createSlice({
    name: 'workPointsPost',
    initialState,
    reducers: {
        updateDialogOpen(state, action) {
            state.dialogOpen = action.payload;
        },
    },
    extraReducers(builder) {
        builder
          .addCase(postNewWorkPointEntry.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postNewWorkPointEntry.fulfilled, (state, action) => {
            state.status = APIRequestStatus.Success;

            state.dialogOpen = false;
          })
          .addCase(postNewWorkPointEntry.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("fetch is failure");
          })
      }
})

export const postNewWorkPointEntry = createAsyncThunk('workPointsPost/postNewWorkPointEntry', async (arg: any, thunkAPI) => {

    const response = await axios({
      method: 'post',
      url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/employee-points',
      data: arg
    });

    return response.data
})

export const { updateDialogOpen } = workPointsPostSlice.actions

export default workPointsPostSlice.reducer